<template>
    <section class="hero">
        <div class="hero__content container">
            <p class="hero__description top --fade-in-up" data-vertical-ivp-class="--animate">
                Invest in 
            </p>
            <h1 class="hero__title --fade-in-up" data-vertical-ivp-class="--animate" >The Profitable World of Extended Warranties, w/ an Eye on the Future of E-Commerce</h1>
            <p class="hero__description --fade-in-up" data-vertical-ivp-class="--animate">
                The core focus of MHHC Enterprises Inc. is to develop business opportunities, 
                relationships, and new enterprises that create revenue growth through the sale 
                of value added Extended Protection Plans for consumer electronics, 
                that consistently protect Homeowners Assets, and creating value added Warranty Performance 
                Programs for manufacturers.
            </p>
            <div class="btn --fade-in-up" data-vertical-ivp-class="--animate">
              <a href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view" target="_blank">
                <button class="button">
                  Invest Now
                </button>
              </a>
            </div>
        </div>
    </section>
  </template>
  
  
<script>
export default {
name: 'hero',
data () {
    return {
    }
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/hero.scss";
</style>